import React from 'react'

// Import Sections
import Hero from '../Views/Home/Hero'
import Verticals from '../Views/Home/Verticals'
import Partners from '../Views/Home/Partners'
// Import Content
import { partnerTiles } from './partnerTiles'
import FeatureArtwork from '../Views/Home/FeatureArtwork'

const verticalsTiles = [
  {
    h: 'Internet of Things',
    p:
      'Secure location verification and localization for networks of IoT devices.',
    img: { src: '', alt: '' },
    video: { src: '/bigAssets/IoT.mp4', alt: '' }
  },
  {
    h: 'Geospatial Data',
    p:
      'Data provenance and attribution to support the development of decentralized data-markets.',
    img: { src: '', alt: '' },
    video: { src: '/bigAssets/Geodata.mp4', alt: '' }
  },
  {
    h: 'Supply Chain',
    p:
      'Verifiable and precise product tracking from supplier to customer, with all the steps in-between.',
    img: { src: '', alt: '' },
    video: { src: '/bigAssets/Supply.mp4', alt: '' }
  },
  {
    h: 'Mobility',
    p:
      'Location tracking and fraud prevention to support the growth of mobility services and autonomous vehicles.',
    img: { src: '', alt: '' },
    video: { src: 'bigAssets/Mobility.mp4', alt: '' }
  },
  {
    h: 'Insurance',
    p:
      'Automated conflict resolution and contract enforcement through the trusted reporting of spatial information.',
    img: { src: '', alt: '' },
    video: { src: '/bigAssets/InsuranceLight.mp4', alt: '' }
  },
  {
    h: 'Location Intelligence',
    p:
      'Spatial attribution added to the toolkit of blockchain-enabled analytics.',
    img: { src: '', alt: '' },
    video: { src: '/bigAssets/Presence.mp4', alt: '' }
  }
]

const home = [
  {
    key: 'hero',
    component: Hero,
    color: 'LIGHT',
    shadow: true,
    main: {
      h: [
        'Secure and',
        <br key="home-hero-main-h-br1" />,
        'Transparent',
        <br key="home-hero-main-h-br2" />,
        'Location Data'
      ],
      p: [
        'FOAM provides the tools to enable a crowdsourced map and decentralized location services.',
        <br key="home-hero-main-h-br3" />,
        <br key="home-hero-main-h-br4" />,
        'Learn more:'
      ],
      cta: [
        // {
        //   path: '/token',
        //   text: 'FOAM Map is live on Ethereum mainnet!',
        //   type: 'PLAINTEXT',
        //   new: false
        // },
        // {
        //   path: 'https://map.foam.space',
        //   text: 'Start Mapping',
        //   type: 'EXTERNAL-BUTTON',
        //   new: false,
        //   onClickHandler: () =>
        //     ReactGA.event({
        //       category: 'cta_click',
        //       action: 'home_start_mapping'
        //     })
        // },
        {
          path: '/map',
          text: 'FOAM Map',
          type: 'INTERNAL'
        },
        {
          path: '/location',
          text: <img src="/publicAssets/foam-location.svg" alt="" />,
          type: 'INTERNAL-IMAGE',
          new: false
        }
      ],
      justification: 'LEFT',
      width: 'NARROW'
    },
    video: {
      hidePlayBtn: true,
      src: '/bigAssets/FOAM_short_harder.mp4',
      alt: 'Your browser does not support the video tag.'
    }
  },
  {
    key: 'featureArtwork',
    component: FeatureArtwork,
    color: 'LIGHT',
    main: [
      {
        h: [
          'Location data without',
          <br key="home-featureArtwork-main1-h-br1" />,
          'Satellites.'
        ],
        p: [
          'The stock market, supply chains, the airline industry, the electrical grid, communication networks and more rely on GPS.',
          <br key="home-featureArtwork-main1-p-br1" />,
          <br key="home-featureArtwork-main1-p-br2" />,
          'But GPS is vulnerable to hacking and spoofing, leaving our critical infrastructure unprotected. Secure location verification is urgently needed across an array of industries.',
          <br key="home-featureArtwork-main1-p-br3" />,
          <br key="home-featureArtwork-main1-p-br4" />,
          'FOAM solves the problem of location verification with an alternative, fault-tolerant system provided through an open network of terrestrial radios that anyone can operate.'
        ],
        img: (
          <div className="FeatureArtwork-itemContentArtworkWrapper">
            <div className="RatioBox">
              <video className="RatioBox-item" autoPlay muted loop playsInline>
                {' '}
                <source src={'/bigAssets/GPS.mp4'} type={'video/mp4'} />{' '}
              </video>
            </div>
          </div>
        )
      },
      {
        h: ['Open Source.'],
        p: [
          'FOAM invites individuals, businesses, and organizations to join together in a community-owned and operated location network. ',
          <br key="home-featureArtwork-main2-p-br1" />,
          <br key="home-featureArtwork-main2-p-br2" />,
          'FOAM Map and FOAM Location provide more resilient alternatives to centralized maps and location services but without a single point of failure.',
          <br key="home-featureArtwork-main2-p-br3" />,
          <br key="home-featureArtwork-main2-p-br4" />,
          'By putting a verification layer at the core, others can build on top of FOAM data and know that it can be trusted. '
        ],
        img: (
          <div className="FeatureArtwork-itemContentArtworkWrapper">
            <div className="RatioBox RatioBox--ratio2X1">
              <video className="RatioBox-item" autoPlay muted loop playsInline>
                {' '}
                <source src={'/bigAssets/PoL.mp4'} type={'video/mp4'} />{' '}
              </video>
            </div>
          </div>
        )
      },
      {
        h: ['Built on blockchain.'],
        p: [
          'FOAM is built on the Ethereum blockchain, a decentralized database that is secure without a third party or gatekeeper.',
          <br key="home-featureArtwork-main3-p-br1" />,
          <br key="home-featureArtwork-main3-p-br2" />,
          'Blockchains mean that FOAM is transparent and censorship-resistant, and can provide secure location data for other applications. ',
          <br key="home-featureArtwork-main3-p-br3" />,
          <br key="home-featureArtwork-main3-p-br4" />,
          'The FOAM token gives participants control over their location network and requires them to make decisions that impact its future.'
        ],
        img: (
          <div className="FeatureArtwork-itemContentArtworkWrapper">
            <div className="RatioBox RatioBox--ratio4X3">
              <video className="RatioBox-item" autoPlay muted loop playsInline>
                {' '}
                <source src={'/bigAssets/rp.mp4'} type={'video/mp4'} />{' '}
              </video>
            </div>
          </div>
        )
      }
    ]
  },
  {
    key: 'verticals',
    component: Verticals,
    color: 'LIGHT',
    main: {
      h: 'A Field of Applications.',
      p: [
        'Verified location data benefits a wide',
        <br key="home-verticals-main-p-br1" />,
        'range of use-cases.'
      ],
      cta: {
        path: 'https://blog.foam.space',
        text: 'Check Out Our Blog',
        type: 'EXTERNAL'
      },
      justification: 'LEFT',
      width: 'WIDE'
    },
    verticalsTiles: verticalsTiles
  },
  {
    key: 'partners',
    component: Partners,
    color: 'DARK',
    partnerTiles
  }
]

export { home }



// WEBPACK FOOTER //
// ./src/content/homePage.js